/**
 * © 2026 Madar.iq — جميع الحقوق محفوظة
 * هذا الملف جزء من منظومة Madar.iq البرمجية.
 * يُحظر نسخه أو تعديله أو توزيعه دون إذن كتابي.
 * All Rights Reserved — Unauthorized use is prohibited.
 */
import { useState } from "react";
import { FaGlobe } from "react-icons/fa";
import { COLORS } from "./navbar.constants";
import { useTranslation } from "react-i18next";

export default function LangToggleButton() {
  const { i18n } = useTranslation();
  const isArabic = i18n.language === "ar";
  const [isHovered, setIsHovered] = useState(false);

  const toggleLang = () => {
    const next = isArabic ? "en" : "ar";
    i18n.changeLanguage(next);
    localStorage.setItem("lang", next);
    document.documentElement.lang = next;
    document.documentElement.dir = next === "ar" ? "rtl" : "ltr";
    document.body.dir = next === "ar" ? "rtl" : "ltr";
  };

  return (
    <button
      className="btn fw-semibold d-flex align-items-center gap-2"
      onClick={toggleLang}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      style={{
        color: isHovered ? COLORS.darkPurple : COLORS.textLight,
        background: isHovered ? COLORS.gold : "transparent",
        border: `1.8px solid ${COLORS.gold}`,
        borderRadius: "12px",
        padding: "6px 16px",
        boxShadow: isHovered
          ? "0 4px 14px rgba(242,180,65,0.35)"
          : "0 2px 6px rgba(0,0,0,0.15)",
        transition: "all 0.3s ease",
        fontSize: "1rem",
      }}
    >
      <FaGlobe
        style={{
          color: isHovered ? COLORS.darkPurple : COLORS.gold,
          fontSize: "1.1rem",
        }}
      />
      {isArabic ? "EN" : "AR"}
    </button>
  );
}
